import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UserLoginContext } from '../../../contexts/LoggedInUserContext';
import { ImgLazyload } from '../Common';
import './cartmodal.scss';
import { handleKettoLinks } from '../../../services/helperFunctions';
import { sendEvents } from '../../../redux/actions/Home';
import HeartWhite from '../../public/images/heart-white.png';

const cartDetails = {
  2: {
    title: 'Uh-oh! There’s an issue…',
    desc: 'Processing your card. Change payment methods & make a difference.',
    cta: 'Resume',
  },
  4: {
    title: 'They still need you',
    desc: 'Resume your giving journey today.',
    cta: 'Resume',
  },
  medical: {
    title: 'Save Lives',
    desc: 'Help <b>6.8+ Cr</b> people who can’t afford their treatments.',
    cta: 'Sign up',
  },
  animals: {
    title: 'Help a Furry Friend',
    desc: '<b>7.9 Cr</b> homeless pets in India need aid.',
    cta: 'Sign up',
  },
  women_girls: {
    title: 'Stand up for Women',
    desc: 'Shape a better world for our mothers, sisters & daughters.',
    cta: 'Sign up',
  },
  education: {
    title: 'Educate our kids',
    desc: 'Books, uniforms & transport for <b>8.4 Cr</b> kids out of school.',
    cta: 'Sign up',
  },
  food_hunger: {
    title: 'Feed India',
    desc: '<b>33 Lakh</b> hungry children need a timely meal.',
    cta: 'Sign up',
  },
  widow: {
    title: 'Widows in Need',
    desc: 'Help <b>4 Cr</b> women rebuild their lives.',
    cta: 'Sign up',
  },
  elderly: {
    title: 'Our elders need you',
    desc: 'Save them from abandonment & hunger.',
    cta: 'Sign up',
  },
};

function CartModal() {
  const { multiArray, userData } = useContext(UserLoginContext);
  const cartSip = localStorage.getItem('cartCause')
    ? JSON.parse(localStorage.getItem('cartCause'))
    : null;
  const [isHidden, setIsHidden] = useState(false);
  const history = useHistory();
  const [dragStartY, setDragStartY] = useState(null);
  const [dragDistance, setDragDistance] = useState(0);
  const [cartData, setCartData] = useState({ title: '', desc: '', cta: '' });
  const cartInfo = cartSip?.status_flag && cartSip?.status_flag != 1 && cartSip?.status_flag != 6
    ? cartSip?.status_flag
    : cartSip?.campaign_cause;
  
  useEffect(() => {
    const checkCartSip = !!cartSip
      && multiArray?.find((item) => item.campaign_cause == cartSip.campaign_cause);
    const checkIsAlreadySubscribed = (checkCartSip && checkCartSip.label) == cartSip?.label;
    const urlArrays = [];
    if (cartSip?.campaign_cause) {
      urlArrays.push(
        `/${
          cartSip.campaign_cause == 'animals'
            ? 'animal'
            : cartSip.campaign_cause
        }cause`,
      );
    }
    multiArray.forEach((item) => urlArrays.push(`/${item.campaign_cause}cause`));
    if (urlArrays.includes(window.location.pathname)) {
      setIsHidden(true);
    } else if (!cartSip) {
      setIsHidden(true);
    } else if (cartSip?.status_flag == 5) {
      setIsHidden(true);
    } else if (checkCartSip?.status_flag == 1) {
      setIsHidden(true);
    } else if (!checkIsAlreadySubscribed) {
      setIsHidden(true);
    } else {
      setIsHidden(false);
    }
    setCartData(cartDetails[cartInfo]);
  }, [multiArray, cartSip]);

  useEffect(() => {
    if (cartInfo && cartSip) {
      sendEvents(
        'pageView',
        'sip_returning',
        'cart_popup',
        !isNaN(cartInfo) ? `impact_${cartInfo}` : cartInfo,
        '',
      );
    }
  }, []);

  if (isHidden) {
    return null; // Render nothing if the card is hidden
  }

  const onCartSip = () => {
    if (
      cartSip?.status_flag
      && cartSip?.status_flag != 1
      && cartSip?.status_flag != 6
    ) {
      sendEvents(
        'update_payment_clicked',
        'sip_returning',
        'cart_popup',
        cartSip?.campaign_cause,
        `impact_${cartSip?.status_flag}`,
      );
      window.location.href = handleKettoLinks(
        `new/sip/change-payment?pr=c&email=${userData?.email}&sip_cause=${cartSip?.campaign_cause}`,
      );
    } else {
      localStorage.removeItem('cartCause');
      sendEvents(
        `${cartSip?.campaign_cause}Card_clicked`,
        'sip_returning',
        'cart_popup',
        cartSip?.campaign_cause,
      );
      history.push(
        `${
          cartSip.campaign_cause == 'animals'
            ? 'animal'
            : cartSip.campaign_cause
        }cause?cartInfo=true`,
      );
    }
  };

  const handleTouchStart = (e) => {
    e.preventDefault(); // Prevent the default browser behavior
    setDragStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    e.preventDefault(); // Prevent the default browser behavior
    if (dragStartY !== null) {
      const currentY = e.touches[0].clientY;
      const distance = currentY - dragStartY;
      // Only allow downward swipe
      const clampedDistance = distance < 0 ? 0 : distance;
      if (clampedDistance >= 20) {
        setDragDistance(20);
      }
    }
  };

  const handleTouchEnd = () => {
    if (dragDistance >= 20) {
      setIsHidden(true);
      sendEvents(
        'close_cart',
        'sip_returning',
        'cart_popup',
        !isNaN(cartInfo) ? `impact_${cartInfo}` : cartInfo,
        '',
      );
      localStorage.removeItem('cartCause');
    }
    setDragStartY(null);
    setDragDistance(0);
  };

  const handleTouchCancel = () => {
    setDragStartY(null);
    setDragDistance(0);
  };

  return (
    <div className="cart_main_container">
      <div
        className="cart_main_body web-hide "
        style={{
          transform: `translateY(${dragDistance}px)`,
          display: !isHidden ? 'block' : 'none',
          bottom: '70px',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onTouchCancel={handleTouchCancel}>
        <div className="cart_wrapper">
          <div className="d-flex justify-content-center">
            <div className="slide-line" />
          </div>
          <div className="d-flex align-items-center cart_body">
            <div className="d-flex align-items-center">
              <div className="position-relative">
                <ImgLazyload
                  src={cartSip?.sip_cause?.info_3}
                  alt={cartSip?.sip_cause?.info_2}
                  className="causes_img" />
                <div className="position-absolute heart_icon">
                  <ImgLazyload
                    src={HeartWhite}
                    alt="heart-white"
                    style={{ width: '15px', height: '15px' }} />
                </div>
              </div>
              <div className="cart_text_box">
                <p className="fs-17 lh-20 mb-0 title">{cartData?.title}</p>
                <p
                  className="fs-10 lh-15 mb-0"
                  dangerouslySetInnerHTML={{ __html: cartData?.desc }}>
                </p>
              </div>
            </div>
            <div className="" onClick={onCartSip}>
              <p className="mb-0 fs-12 lh-18 cart_button">{cartData?.cta}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(CartModal);
